module.exports = __webpack_public_path__ + "img/type10050.a3d220b9.png";